// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__5RNjn","head":"ProcedureTableInfo_head__3sThz"};